import React from "react"
import { Link } from "gatsby"

import HeaderComponent  from './header/header';
import FooterComponent  from './footer/footer';


const Layout = ({ location, title, children, availableCategories, breadcrumbs }) => {
  // const rootPath = `${__PATH_PREFIX__}/`
  // let header

  return (
    <div>
      <HeaderComponent availableCategories={availableCategories} breadcrumbs={breadcrumbs} />
      <main>{children}</main>
      <FooterComponent availableCategories={availableCategories}  />
    </div>
  )
}

export default Layout
